const NOTIFICATION_ICONS: Record<string, string> = {
  success: 'check',
  errorFilled: 'info-filled',
  error: 'info-filled',
  notification: 'bell',
  close: 'close',
};

export const mapIcon = (name: string): string => NOTIFICATION_ICONS[name] || name;

export const positionList: Array<string> = [
  'top-left',
  'top-right',
  'bottom-left',
  'bottom-right',
  'top',
  'bottom',
  'left',
  'right',
  'center',
];

export const badgePositions: Array<string> = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

export const positionClass: Record<string, string> = {};

positionList.forEach((pos) => {
  const vert
    = ['left', 'center', 'right'].includes(pos) === true
      ? 'center'
      : pos.includes('top')
        ? 'top'
        : 'bottom';
  const align
    = pos.includes('left')
      ? 'start'
      : pos.includes('right')
        ? 'end'
        : 'center';
  const classes = ['left', 'right'].includes(pos)
    ? `items-${ pos === 'left' ? 'start' : 'end' } justify-center`
    : pos === 'center'
      ? 'flex-center'
      : `items-${ align }`;

  positionClass[pos] = `v-notifications__list v-notifications__list--${ vert } ${ classes }`;
});
